import i18n from '../i18n';

/**
 * Returns common headers for API calls, including the Accept-Language header
 * based on the current i18n language.
 */
export default function getApiHeaders(extra = {}) {
    return {
        'Content-Type': 'application/json',
        'Accept-Language': i18n.language || 'en',
        ...extra
    };
}
